module.exports = __webpack_public_path__ + "static/media/dashboard.6c04d1c0.svg";